import * as widgets from "../widgets/ColorFieldWidget";
import {fieldValue} from "../common/NamaCommon";

export function colorColumnEditor(fieldMetadata, trimmedFieldId, grid) {
    return (container, options) => {
        let widget = new widgets.ColorFieldWidget({owner: grid, fieldMetadata, cellOptions: options});
        widget.inputName = options.field;
        grid.afterAddingToGridAction(widget, options, trimmedFieldId, container);
    }
}

export function colorTemplate(fieldId, trimmedFieldId) {

    return (dataItem) => {
        let value = fieldValue(dataItem, trimmedFieldId);
        if (!value)
            return "";
        return `<span title='${value}' style ='background-color:${value}'>${value}</span>`;
    }
}